/* eslint-disable no-console */
import React, { ReactNode } from 'react';
import { useTranslation } from 'next-i18next';

import { ErrorBoundary } from '@restworld/utils-common';

import { Heading } from '@restworld/ui-ds-base';

interface ErrorBoundaryProps {
  children: ReactNode;
}
export const ErrorBoundaryWrapper: React.FC<ErrorBoundaryProps> = ({ children }) => {
  // Read here, before anything can crash: the fallback renders after a failure,
  // and `common` is loaded by all 22 pages that call getServerTranslations, so
  // the crash screen cannot fall back to a raw key.
  const { t } = useTranslation('common');

  return (
    <ErrorBoundary
      onError={(error, componentStack) => {
        // The boundary already reports the error to OpenObserve RUM; this is just local logging.
        console.trace(error, 'page error');
        console.trace(componentStack, 'page error componentStack');
      }}
      fallback={
        <div className="fixed top-[50%] left-[50%] -mt-[150px] -ml-[300px] max-w-2xl min-w-104 p-8">
          <Heading size={1} weight="bold">
            {t('unexpected_error_contact_support')}
          </Heading>
        </div>
      }
    >
      {children}
    </ErrorBoundary>
  );
};
export default ErrorBoundaryWrapper;
